import { useEffect, useState } from "react";
import "@assets/css/Clock.css";

const ClockHand = ({ className = "" }) => {
  const [angle, setAngle] = useState(0);

  useEffect(() => {
    const updateRotation = () => {
      const now = new Date();
      const seconds = now.getSeconds();
      const degrees = (seconds / 60) * 360;
      setAngle(degrees);
    };

    updateRotation();
    const interval = setInterval(updateRotation, 1000); 

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`clock ${className}`}>
      <div
        className="hand"
        style={{
          transform: `translateX(-50%) rotate(${angle}deg)`,
        }}
      />
    </div>
  );
};

export default ClockHand;
